import { css } from '@genesislcap/web-core';

/** Amber highlight color (price-change pills, status pills, competitive type). */
export const HIGHLIGHT_AMBER_COLOR = ' #ffdf94';
/** Amber highlight background (same hue, 20% opacity). */
export const HIGHLIGHT_AMBER_BG = 'rgb(255, 223, 148, 0.2)';

/** Deals listing: submitted qty capsule (background / text). */
export const ORDER_SUBMITTED_PILL_BG = ' #7acc79';
export const ORDER_SUBMITTED_PILL_TEXT = '#054728';
/** Deals listing: draft qty capsule (background / text). */
export const ORDER_DRAFT_PILL_BG = 'rgba(251, 191, 36, 0.2)';
export const ORDER_DRAFT_PILL_TEXT = '#fcd34d';

/** Reconfirm row/tab highlight – blue gradient and border. */
export const HIGHLIGHT_RECONFIRM_BLUE = '#4a9eff';
export const HIGHLIGHT_RECONFIRM_BG = 'rgb(74, 158, 255, 0.25)';

/** Dark grey for cancel/secondary button and borders. */
export const cancelButtonBg = '#2e3339';
/** Dark grey hover state for cancel/secondary button. */
export const cancelButtonBgHover = '#3a3f45';

export const mixinScreen = (display: string = 'block') => `
  contain: content;
  display: ${display};
  height: 100%;
  width: 100%;
`;

export const labelStyles = `
  .label {
    font-weight: 700;
    color: var(--rapid-ag-header-foreground-color);
  }
`

export const closeIconStyles = css`
  rapid-modal::part(close-icon),
  .submit-modal::part(close-icon),
  .close-icon {
    transition: background-color 0.2s ease;
    background: transparent;
  }

  rapid-modal::part(close-icon) {
    font-size: x-large;
  }

  rapid-modal::part(close-icon):hover,
  .submit-modal::part(close-icon):hover,
  .close-icon:hover {
    background: rgba(255, 255, 255, 0.1) !important;
  }
`

export const dealInformationItem = `
  .deal-information-item {
    padding: 5px 10px;
    flex: 1;
  }
`

/**
 * Class name for {@link thinHorizontalScrollbarStyles}. Theme on the element or `:host`:
 * `--thin-h-scroll-height`, `--thin-h-scroll-height-hover`, `--thin-h-scroll-thumb`,
 * `--thin-h-scroll-thumb-hover`, `--thin-h-scroll-track`, `--thin-h-scroll-radius`,
 * `--thin-h-scroll-padding-bottom`, `--thin-h-scroll-max-width`, `--thin-h-scroll-min-width`.
 */
export const THIN_HORIZONTAL_SCROLL_CLASS = 'thin-h-scroll';

/** Horizontal overflow strip + thin scrollbar (also targets `rapid-tabs::part(tablist)`). */
export const thinHorizontalScrollbarStyles = css`
  .thin-h-scroll,
  rapid-tabs::part(tablist) {
    overflow-x: auto;
    overflow-y: hidden;
    box-sizing: border-box;
    width: 100%;
    max-width: var(--thin-h-scroll-max-width, 100%);
    min-width: var(--thin-h-scroll-min-width, 0);
    padding-bottom: var(--thin-h-scroll-padding-bottom, 8px);
  }

  .thin-h-scroll::-webkit-scrollbar,
  rapid-tabs::part(tablist)::-webkit-scrollbar {
    height: var(--thin-h-scroll-height, 4px);
    background: var(--thin-h-scroll-track, transparent);
  }

  .thin-h-scroll::-webkit-scrollbar-track,
  rapid-tabs::part(tablist)::-webkit-scrollbar-track {
    background: var(--thin-h-scroll-track, transparent);
  }

  .thin-h-scroll::-webkit-scrollbar-thumb,
  rapid-tabs::part(tablist)::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: var(--thin-h-scroll-radius, 2px);
  }

  .thin-h-scroll:hover::-webkit-scrollbar,
  rapid-tabs::part(tablist):hover::-webkit-scrollbar {
    height: var(--thin-h-scroll-height-hover, var(--thin-h-scroll-height, 4px));
  }

  .thin-h-scroll:hover::-webkit-scrollbar-thumb,
  rapid-tabs::part(tablist):hover::-webkit-scrollbar-thumb {
    background-color: var(--thin-h-scroll-thumb, rgba(255, 255, 255, 0.3));
  }

  .thin-h-scroll:hover::-webkit-scrollbar-thumb:hover,
  rapid-tabs::part(tablist):hover::-webkit-scrollbar-thumb:hover {
    background-color: var(--thin-h-scroll-thumb-hover, rgba(255, 255, 255, 0.5));
  }

  @supports (-moz-appearance: none) {
    .thin-h-scroll,
    rapid-tabs::part(tablist) {
      scrollbar-width: none;
    }

    .thin-h-scroll:hover,
    rapid-tabs::part(tablist):hover {
      scrollbar-width: thin;
      scrollbar-color: var(--thin-h-scroll-thumb, rgba(255, 255, 255, 0.3))
        var(--thin-h-scroll-track, transparent);
    }
  }
`;
